import { atom } from 'jotai';

const component = atom<React.ReactNode>(undefined);
const show = atom<boolean>(false);

export const modal = {
  component,
  show,
};
